<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary" show-arrows>
      <v-tab ripple :key="'booking'" :href="'#booking'">
        {{ $t('booking') }}
      </v-tab>

      <v-tab ripple :key="'messages'" :href="'#setting'">
        {{ $t('Setting') }}
      </v-tab>

      <v-tab-item v-if="currentView == 'booking'" :key="1" :value="'booking'">
        <Booking />
      </v-tab-item>
      <v-tab-item v-if="currentView == 'setting'" :key="3" :value="'setting'">
        <Setting />
      </v-tab-item>
    </v-tabs>

    <template> </template>
  </div>
</template>

<script>
import Setting from './Setting.vue'
import Booking from './Booking.vue'

export default {
  data() {
    return {
      currentView: 'booking'
    }
  },
  components: {
    Setting,
    Booking
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/intent/calendar/Controller.vue